export default [
  {
    path: 'find',
    name: 'Find',
    meta: {
      title: '星圈'
    },
    component: () =>
      import('../views/exerland/Find.vue')
  },
  {
    path: 'dynamic',
    name: 'Dynamic',
    meta: {
      title: '发现'
    },
    component: () =>
      import('../views/exerland/dynamic/list.vue')
  },
  {
    path: 'filterFind/:id/:title',
    name: 'FilterFind',
    meta: {
      title: '发现'
    },
    component: () =>
      import('../views/exerland/dynamic/filterFind.vue')
  },
  {
    path: 'refining',
    name: 'Refining',
    meta: {
      title: '开炼'
    },
    component: () =>
      import(
        '../views/exerland/refining/Refining.vue'
      )
  },
  {
    path: 'groupsList',
    name: 'GroupsList',
    meta: {
      title: '圈子'
    },
    component: () =>
      import(
        '../views/exerland/groups/groupsList.vue'
      )
  },
  {
    path: 'liveList',
    name: 'LiveList',
    meta: {
      title: '直播'
    },
    component: () =>
      import('../views/exerland/liveList.vue')
  },
  {
    path: 'center',
    name: 'Center',
    meta: {
      title: '我的'
    },
    component: () =>
      import('../views/exerland/center/Center.vue')
  },
  {
    path: 'editUserInfo',
    name: 'EditUserInfo',
    meta: {
      title: '个人信息'
    },
    component: () =>
      import(
        '../views/exerland/center/editInfo.vue'
      )
  },
  {
    path: 'communication',
    name: 'Communication',
    component: () =>
      import(
        '../views/exerland/Communication/Index.vue'
      ),
    redirect: '/communication/list',
    children: [{
      path: 'list',
      name: 'CommunicationdList',
      meta: {
        title: '发现'
      },
      component: () =>
        import(
          '../views/exerland/Communication/List.vue'
        )
    },
    {
      path: 'details/:id',
      name: 'CommunicationdDetails',
      component: () =>
        import(
          '../views/exerland/Communication/Details.vue'
        )
    }
    ]
  }
]
